import { render, staticRenderFns } from "./NotUpdatableAfterCreation.vue?vue&type=template&id=5a5908f4&"
import script from "./NotUpdatableAfterCreation.vue?vue&type=script&lang=js&"
export * from "./NotUpdatableAfterCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports